import messagesEN from "./en_messages.json";
import messagesFI from "./fi_messages.json";
import messagesSV from "./sv_messages.json";

const messages: { [key: string]: any } = {
  fi: messagesFI,
  en: messagesEN,
  sv: messagesSV,
};

export default messages;
